module.exports = "https://cdn01.riselinkedu.com/assets/images/share@2x.5ba380a.png";